"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uuid = require("uuid");

require("what-input");

var _popover = _interopRequireDefault(require("@paprika/popover"));

var _helpers = require("@paprika/helpers");

var _helpers2 = require("@paprika/stylers/lib/helpers");

var _Content = _interopRequireDefault(require("./components/Content"));

var _Divider = _interopRequireDefault(require("./components/Divider"));

var _Trigger = _interopRequireDefault(require("./components/Trigger"));

var _LinkItem = _interopRequireDefault(require("./components/LinkItem"));

var _Item = _interopRequireDefault(require("./components/Item"));

var sc = _interopRequireWildcard(require("./OverflowMenu.styles"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

var propTypes = {
  /** Where the popover content is positioned relative to the trigger or getPositioningElement. */
  align: _propTypes["default"].oneOf([_popover["default"].types.align.TOP, _popover["default"].types.align.RIGHT, _popover["default"].types.align.BOTTOM, _popover["default"].types.align.LEFT]),

  /** Children should consist of <OverflowMenu.Item /> */
  children: _propTypes["default"].node.isRequired,

  /** If provided, will align Popover to specified edge of Trigger */
  edge: _propTypes["default"].oneOf([_popover["default"].types.align.LEFT, _popover["default"].types.align.RIGHT, null]),

  /** Control if the overflow menu popover open. */
  isOpen: _propTypes["default"].bool,

  /** The maximum height of the OverflowMenu content */
  maxHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

  /** If provided, will fire when the Popover is closed */
  onClose: _propTypes["default"].func,

  /** The z-index for the popover / confirmation */
  zIndex: _propTypes["default"].number
};
var defaultProps = {
  align: _popover["default"].types.align.BOTTOM,
  edge: null,
  isOpen: null,
  maxHeight: 300,
  onClose: null,
  zIndex: (0, _helpers2.zValue)(1)
};
var popoverOffset = 4;

var OverflowMenu = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var align = props.align,
      children = props.children,
      edge = props.edge,
      controlledIsOpen = props.isOpen,
      onClose = props.onClose,
      zIndex = props.zIndex,
      maxHeight = props.maxHeight,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["align", "children", "edge", "isOpen", "onClose", "zIndex", "maxHeight"]);

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      isOpen = _React$useState2[0],
      setIsOpen = _React$useState2[1];

  var _React$useState3 = _react["default"].useState(false),
      _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
      isConfirming = _React$useState4[0],
      setIsConfirming = _React$useState4[1];

  var _React$useState5 = _react["default"].useState(0),
      _React$useState6 = (0, _slicedToArray2["default"])(_React$useState5, 2),
      currentFocusIndex = _React$useState6[0],
      setFocusIndex = _React$useState6[1];

  var triggerRef = _react["default"].useRef(null);

  var _React$useState7 = _react["default"].useState(function () {
    return "overflow-menu_".concat((0, _uuid.v4)());
  }),
      _React$useState8 = (0, _slicedToArray2["default"])(_React$useState7, 1),
      menuId = _React$useState8[0];

  var _React$useState9 = _react["default"].useState(function () {
    return "overflow-menu-trigger_".concat((0, _uuid.v4)());
  }),
      _React$useState10 = (0, _slicedToArray2["default"])(_React$useState9, 1),
      triggerId = _React$useState10[0];

  var overflowListRef = _react["default"].useRef(null);

  var renderConfirmationRef = _react["default"].useRef(null);

  function focusAndSetIndex(index) {
    if (overflowListRef && overflowListRef.current && index !== undefined) overflowListRef.current.querySelectorAll('[data-pka-anchor="overflow-menu.item"]')[index].focus();
    setFocusIndex(index);
  }

  _react["default"].useImperativeHandle(ref, function () {
    return {
      focusAndSetIndex: focusAndSetIndex
    };
  });

  function getIsOpenValue() {
    return controlledIsOpen === null ? isOpen : controlledIsOpen;
  }

  function setIsOpenValue(value) {
    if (controlledIsOpen !== null) return;
    setIsOpen(value);
  }

  var handleCloseMenu = function handleCloseMenu(key) {
    setIsOpenValue(false);

    if (isConfirming) {
      setIsConfirming(false);
      renderConfirmationRef.current = null;
    }

    if (triggerRef.current && key === "Tab") {
      triggerRef.current.focus();
    }

    if (onClose) {
      onClose();
    }
  };

  var handleOpenMenu = function handleOpenMenu() {
    setIsOpenValue(true);

    if (document.querySelector("html").getAttribute("data-whatinput") === "keyboard") {
      setTimeout(function () {
        focusAndSetIndex(0);
      }, 250);
    }
  };

  var _extractChildren = (0, _helpers.extractChildren)(children, ["OverflowMenu.Trigger", "OverflowMenu.Content"]),
      Trigger = _extractChildren["OverflowMenu.Trigger"],
      Content = _extractChildren["OverflowMenu.Content"],
      extractedChildren = _extractChildren.children;

  var ContentProps = Content && Content.props ? Content.props : null;
  var overflowLastItemIndex = _react["default"].Children.toArray(extractedChildren.filter(function (child) {
    return child.type && (child.type.displayName === "OverflowMenu.Item" || child.type.displayName === "OverflowMenu.LinkItem");
  })).length - 1;

  var _onKeyDown = function onKeyDown(event, currentIndex) {
    if (event.key === "ArrowDown") {
      event.preventDefault();
      var indexToFocus = currentIndex === overflowLastItemIndex ? 0 : currentIndex + 1;
      focusAndSetIndex(indexToFocus);
    } else if (event.key === "ArrowUp") {
      event.preventDefault();

      var _indexToFocus = currentIndex === 0 ? overflowLastItemIndex : currentIndex - 1;

      focusAndSetIndex(_indexToFocus);
    } else if (event.key === "Home") {
      event.preventDefault();
      focusAndSetIndex(0);
    } else if (event.key === "End") {
      event.preventDefault();
      focusAndSetIndex(overflowLastItemIndex);
    } else if (event.key === "Enter" || event.key === " ") {// do nothing
    } else {
      handleCloseMenu(event.key);
    }
  };

  var handleShowConfirmation = function handleShowConfirmation(renderConfirmation) {
    renderConfirmationRef.current = renderConfirmation;
    return function () {
      setIsConfirming(function (prevIsConfirmingState) {
        return !prevIsConfirmingState;
      });
    };
  };

  var renderTrigger = function renderTrigger() {
    // wrapping the returned item in a function to avoid needing to tab twice
    // https://github.com/acl-services/paprika/issues/126
    return function () {
      return /*#__PURE__*/_react["default"].cloneElement(Trigger, {
        isOpen: getIsOpenValue(),
        onOpenMenu: handleOpenMenu,
        triggerRef: triggerRef,
        menuId: menuId,
        id: triggerId
      });
    };
  };

  var extractRenderConfirmation = function extractRenderConfirmation() {
    extractedChildren.forEach(function (child) {
      if (child.props.renderConfirmation && child.props.renderConfirmation !== renderConfirmationRef.current) {
        renderConfirmationRef.current = child.props.renderConfirmation;
      }
    });
  };

  var getClonedChild = function getClonedChild(child, childKey) {
    var additionalProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return /*#__PURE__*/_react["default"].cloneElement(child, _objectSpread(_objectSpread({
      onKeyDown: function onKeyDown(e) {
        return _onKeyDown(e, currentFocusIndex);
      }
    }, childKey), additionalProps));
  };

  var renderContent = function renderContent() {
    if (isConfirming) {
      extractRenderConfirmation();
      var confirmationComponent = renderConfirmationRef.current(handleCloseMenu);
      return /*#__PURE__*/_react["default"].cloneElement(confirmationComponent, {
        align: align,
        edge: edge,
        defaultIsOpen: true,
        getPositioningElement: function getPositioningElement() {
          return document.getElementById(triggerId);
        },
        offset: popoverOffset,
        onClose: handleCloseMenu,
        zIndex: zIndex
      });
    }

    return /*#__PURE__*/_react["default"].createElement(sc.PopoverCard, {
      maxHeight: maxHeight
    }, /*#__PURE__*/_react["default"].createElement(sc.Content, {
      ref: overflowListRef
    }, extractedChildren.map(function (child, index) {
      var childKey = {
        key: "OverflowMenuItem".concat(index)
      };

      if (child && child.type && child.type.displayName === "OverflowMenu.Item") {
        if (child.props.renderConfirmation) {
          return getClonedChild(child, childKey, {
            onShowConfirmation: handleShowConfirmation(child.props.renderConfirmation)
          });
        }

        return getClonedChild(child, childKey, {
          onClose: handleCloseMenu
        });
      }

      return getClonedChild(child, childKey);
    })));
  };

  return /*#__PURE__*/_react["default"].createElement(_popover["default"], (0, _extends2["default"])({
    align: align,
    offset: popoverOffset,
    isOpen: getIsOpenValue(),
    edge: edge,
    zIndex: zIndex
  }, moreProps, {
    onClose: function onClose() {
      if (!isConfirming) handleCloseMenu();
    }
  }), /*#__PURE__*/_react["default"].createElement(_popover["default"].Trigger, null, renderTrigger()), /*#__PURE__*/_react["default"].createElement(_popover["default"].Content, (0, _extends2["default"])({
    id: menuId,
    role: !isConfirming ? "menu" : null
  }, ContentProps), getIsOpenValue() && renderContent()));
});

OverflowMenu.displayName = "OverflowMenu";
OverflowMenu.propTypes = propTypes;
OverflowMenu.defaultProps = defaultProps;
OverflowMenu.Content = _Content["default"];
OverflowMenu.Divider = _Divider["default"];
OverflowMenu.LinkItem = _LinkItem["default"];
OverflowMenu.Item = _Item["default"];
OverflowMenu.Trigger = _Trigger["default"];
var _default = OverflowMenu;
exports["default"] = _default;
//# sourceMappingURL=OverflowMenu.js.map